<template>
<div>
  <div class="btn-group btn-group-justified">
    <button @click="addInlineKeyboard" type="button" class="btn btn-outline-secondary btn-sm">Inline Keyboard</button>
    <button @click="removeKeyboard" type="button" class="btn btn-outline-danger btn-sm">Remove</button>
  </div>

  <InlineKeyboard v-if="reply_markup && reply_markup.inline_keyboard" :inline_keyboard="reply_markup.inline_keyboard" :actions="actions">
  </InlineKeyboard>

</div>
</template>


<script>
import InlineKeyboard from '@/components/tasks/fields/InlineKeyboard.vue'



export default {
  name: 'ReplyMarkupInline',
  components: {
    InlineKeyboard
  },
  props: {
    reply_markup: Object,
    actions: Object,
  },
  data: function() {
    return {
      inline_keyboard: {
        "inline_keyboard": []
      }
    }
  },
  methods: {
    addInlineKeyboard: function() {
      this.$emit('changeReplyMarkup', this.inline_keyboard);
    },
    removeKeyboard: function() {
      this.$emit('changeReplyMarkup', null);
    },
  },
}
</script>
